module.exports = __webpack_public_path__ + "static/media/azure_logo.c660e78f.png";